import { useContext } from 'react';
import { toCurrency } from '../../../utilities/FormatHelpers';
import { AccountContext } from '../AccountContext';
import { useCurrentAccountPosition } from '@app/sdk';

export default function CurrentPosition() {
  const { accountId } = useContext(AccountContext);
  const { data: currentAccountPosition } = useCurrentAccountPosition(accountId);

  return (
    <>
      <div className="ui card">
        <div className="custom-card-header">Current Position</div>
        <div className="content">
          {currentAccountPosition && (
            <>
              <p>Status: {currentAccountPosition?.accountPositionStatus.status}</p>
              <p>Total Due: {toCurrency(currentAccountPosition.totalDue?.value)}</p>
              <p>Current Due: {toCurrency(currentAccountPosition.currentDue?.value)}</p>
              <p>Arrears: {toCurrency(currentAccountPosition.arrears.total.value)}</p>
              <p>Remaining Payment Requested: {toCurrency(currentAccountPosition.remainingPaymentRequestedDue.value)}</p>
              <p>Delinquency Days Count: {currentAccountPosition.arrears.delinquencyDayCount ?? "--"}</p>
              {currentAccountPosition.arrears.breakdown.length > 0 && (
                <div>
                  <div className="ui segments">
                    <div className="ui basic segment">
                      {currentAccountPosition.arrears.breakdown.map((arrear) => (
                        <p key={arrear.age}>
                          Age {arrear.age}: {toCurrency(arrear?.amount.value)}
                        </p>
                      ))}
                    </div>
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </>
  );
}
